module.exports = __webpack_public_path__ + "static/media/allVideos.cdc1e067.png";